//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
// fast-crawl-loader imports
import { IProps, IState } from "./fast-crawl-loader.d";
import * as s from "./fast-crawl-loader.styles";
// other internals
import { InfoTip } from "@components/tool-tip";
// state
import { FastCrawlFlowStates } from "@state/onboarding";
// material-ui
import { LinearProgress } from "@material-ui/core";

const stateMessages: { [s: string]: string } = {};
stateMessages[FastCrawlFlowStates.Unstarted] = "Getting started";
stateMessages[FastCrawlFlowStates.CredentialsVerified] = "Processing your calendar...";
stateMessages[FastCrawlFlowStates.UserCrawled] = "Processing your calendar...";
stateMessages[FastCrawlFlowStates.TeammatesIdentified] = "Setting up your team...";
stateMessages[FastCrawlFlowStates.InvitesSuggested] = "Setting up your team...";
stateMessages[FastCrawlFlowStates.TeammatesEventsCrawled] = "Setting up your team...";
stateMessages[FastCrawlFlowStates.CalendarAliasesResolved] = "Setting up your team...";
stateMessages[FastCrawlFlowStates.TeammatesEventsSaved] = "Setting up your team...";
stateMessages[FastCrawlFlowStates.Finished] = "Finishing up...";

const MAX_POINTS = 600;

//////////////////
// COMPONENT
//////////////////
export class FastCrawlLoaderCmpt extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      crawlStatesCompleted: 0,
      cumulativePoints: 0,
      previousDiff: 0,
    };
  }

  public UNSAFE_componentWillReceiveProps(nextProps: IProps) {
    const { flowState } = this.props;
    const { previousDiff } = this.state;
    const currentState = flowState && flowState.current && flowState.current.state;
    const nextState =
      nextProps.flowState && nextProps.flowState.current && nextProps.flowState.current.state;

    const crawlStatesCompleted =
      this.state.crawlStatesCompleted + (currentState !== nextState ? 1 : 0);
    const cumulativePointsDiff =
      (nextProps.flowState &&
        nextProps.flowState.pending &&
        nextProps.flowState.pending.percentComplete) ||
      0;

    // dont go backwards
    const greaterDiff = cumulativePointsDiff > previousDiff ? cumulativePointsDiff : previousDiff;
    const diff = currentState !== nextState ? 0 : greaterDiff;
    this.setState({
      crawlStatesCompleted,
      cumulativePoints: crawlStatesCompleted * 100 + diff,
      previousDiff: diff,
    });
  }

  private getStateMessage() {
    const { flowState } = this.props;
    const currentState = flowState && flowState.current && flowState.current.state;
    if (currentState && currentState in stateMessages) {
      return stateMessages[currentState];
    }

    return "Processing your calendar...";
  }

  public render() {
    const {
      flowState,
      fastCrawlFinished,
      fastCrawlFlowStateErrorMessage,
      fastCrawlTeammatesIdentifiedComplete,
    } = this.props;

    if (!flowState) {
      return <div />;
    }

    const { current, pending } = flowState;
    if (
      (!current && !pending) ||
      (fastCrawlFlowStateErrorMessage && fastCrawlTeammatesIdentifiedComplete) ||
      fastCrawlFinished
    ) {
      return null;
    }

    const classes = Object.assign(
      {},
      {
        root: this.props.classes.loader,
      },
      current.errorMessage
        ? {
            barColorPrimary: this.props.classes.linearProgressErrorPrimary,
            barColorSecondary: this.props.classes.linearProgressErrorSecondary,
          }
        : {},
    );

    return (
      <div
        style={
          !fastCrawlFinished
            ? s.styles.container
            : { visibility: "hidden", height: 0, width: 0, overflow: "hidden" }
        }
      >
        <div className={this.props.classes.state}>
          {current.errorMessage ? (
            <div style={{ display: "flex", alignItems: "center" }}>
              <div>Processing error...</div>
              <InfoTip
                text={
                  <div>
                    <div>Something went wrong.</div>
                    <div>Our engineers are looking into it.</div>
                  </div>
                }
              />
            </div>
          ) : (
            this.getStateMessage()
          )}
        </div>
        <LinearProgress
          variant="determinate"
          value={current.errorMessage ? 75 : (this.state.cumulativePoints / MAX_POINTS) * 100}
          classes={classes}
        />
      </div>
    );
  }
}
